import { SelectedValueReportingFacet } from '../../../../graphql/schema/types/value-reporting'
import { AggregationOptions } from '../../../aggregations'
import { camelCaseToKebabCase } from '../../../text-transformation'
import { getNormalizedFacetName } from './vr-facet-name-helper'

export function mapAggregationsToFacets(filters: AggregationOptions<string>) {
  return Object.keys(filters).reduce<SelectedValueReportingFacet[]>(
    (prev, facetName) => {
      const normalizedFacetName = getNormalizedFacetName(
        facetName,
        camelCaseToKebabCase
      )
      const mappedFilters = filters[facetName].map((selectedFacet) => {
        return {
          facetName: normalizedFacetName,
          facetValue: selectedFacet
        }
      })

      return [...prev, ...mappedFilters]
    },
    []
  )
}
